export default __webpack_public_path__ + "static/media/SeminarioIes2026_IgnacioValero.4a98a1b2.jpg";